import { makeAutoObservable, action, extendObservable } from 'mobx';
class QRCodeStore {
  getDefaultStoreProps() {
    return {
      QRData: {
        qrColor: '#000000',
        qrBackgroundColor: '#ffffff',
        qrLogo: null,
        qrStyle: 'squares',
        qrEyeStyle: [
          { outer: [10, 10, 10, 10], inner: [10, 10, 10, 10] },
          { outer: [10, 10, 10, 10], inner: [10, 10, 10, 10] },
          { outer: [10, 10, 10, 10], inner: [10, 10, 10, 10] },
        ],
        qrUrl: '',
        qrRedirectUrl: '',
        liveStatus: null,
      },
    };
  }

  constructor() {
    makeAutoObservable(this);
    extendObservable(this, { ...this.getDefaultStoreProps() });
  }

  @action
  getQRData = () => this.QRData;

  onChangeField = (name, value) => {
    this.QRData[name] = value;
  };

  @action
  setQRData = (data, entityKey = 'id') => {
    const { qrUrl, qrRedirectUrl, qrColor, qrLogo, qrStyle, qrEyeStyle, qrBackgroundColor } = data;
    this.QRData.entityId = data[entityKey];
    this.QRData.qrUrl = qrUrl;
    this.QRData.qrRedirectUrl = qrRedirectUrl;
    this.QRData.qrColor = qrColor || '#000000';
    this.QRData.qrLogo = qrLogo || null;
    this.QRData.qrStyle = qrStyle || 'squares';
    this.QRData.qrEyeStyle = qrEyeStyle || [
      { outer: [10, 10, 10, 10], inner: [10, 10, 10, 10] },
      { outer: [10, 10, 10, 10], inner: [10, 10, 10, 10] },
      { outer: [10, 10, 10, 10], inner: [10, 10, 10, 10] },
    ];
    this.QRData.qrBackgroundColor = qrBackgroundColor || '#ffffff';
    this.QRData.liveStatus = data.liveStatus || null;
  };

  @action
  updateQRCode = async updateQRCodeFunction => {
    const response = await updateQRCodeFunction(this.QRData, this.QRData.entityId);
    return response;
  };
}

export default new QRCodeStore();
